import React from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

const DeleteIconButton = (props) => {
	// props
	const { onDelete, color = 'default', className } = props;

	return (
		<IconButton
			aria-label='delete'
			onClick={onDelete}
			color={color}
			className={className}
		>
			<DeleteIcon />
		</IconButton>
	);
}

DeleteIconButton.propTypes = {
	onDelete: PropTypes.func,
	color: PropTypes.oneOf(['default', 'primary', 'secondary']),
	className: PropTypes.string
}
export default DeleteIconButton;